// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mapboxgl-marker {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 4px solid white;\n}\n.mapboxgl-popup-content {\n  font: 400 15px/22px 'Inter', sans-serif;\n  background-color: #fbfbfb;\n  border-radius: 5px;\n  min-width: 280px;\n  padding: 0.5rem\n}\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {\n  border-top-color: #fbfbfb;\n}\n", ""]);
// Exports
module.exports = exports;
